
import { defineComponent, computed, ref, inject } from 'vue';
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Home',
  inject: ['$i18n', '$C'],
  setup() {
    const route = useRoute()
    const { t, locale } = useI18n({ useScope: 'global' })
    const changeLang = (lang: string) => {
      locale.value = lang
    }
    const topPageFlg = computed(() => {
      return route.path == '/'
    })
    return {
      changeLang,
      topPageFlg,
      locale,
      t,
    }
  }
});
